import { Controparte } from "./controparte";
import { DocumentoAllegato } from './documento-allegato';
import { Esito } from './esito';

export class SchedaRecupero {
    id: string;
    esito: Esito;
    controparti: Controparte[] = [];
    documenti: DocumentoAllegato[] = [];
    descrizione: string;
    note: string;
    dataCreazione: string;
    constructor(obj: SchedaRecupero){
        if(obj){
            this.id=obj.id;
            this.esito=obj.esito;
            this.controparti=obj.controparti;
            this.documenti=obj.documenti;
            this.descrizione=obj.descrizione;
            this.note=obj.note;
            this.dataCreazione=obj.dataCreazione;
        }
    }
}
